import { PublicTokenApiClient } from '@fourthwall/services/dist/PublicTokenApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreatePublicTokenMutation = createMutationHook(
  PublicTokenApiClient.createPublicToken,
  {
    mutationKey: ['createPublicToken'],
  },
)
